import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import Header from './tpl/Header';
import Leftnavs from './tpl/Leftnavs';
import Footer from './tpl/Footer';

function Default(props) {
    const { component: Component, ...rest } = props;

    return (
        <Route {...rest} render={() => (
            <>
                <Header {...rest} />
                {window.location.hostname.includes('qoctesting') && (
                    <div style={{background:'#ff4d4f',color:'#fff',textAlign:'center',padding:'6px 0',fontSize:13,fontWeight:700,letterSpacing:1,zIndex:9999,position:'sticky',top:0}}>
                        ⚠ This is a Testing Platform — Do not use for real data
                    </div>
                )}
                <div className="page-container">
                    <div className="page-content-wrapper">
                        <Leftnavs {...rest} />
                        <Component {...rest} />
                    </div>
                </div>
                <Footer />
            </>
        )} />
    );
}

export default withRouter(Default);